import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungMerkmalListStatus: 'idle',
    loadMeldungMerkmalListError: undefined as any,
    loadMeldungMerkmalListLastArgs: undefined as any,
    loadMeldungMerkmalStatus: 'idle',
    loadMeldungMerkmalError: undefined as any,
    saveMeldungMerkmalStatus: 'idle',
    saveMeldungMerkmalError: undefined as any,
    deleteMeldungMerkmalStatus: 'idle',
    deleteMeldungMerkmalError: undefined as any,

    meldungMerkmalList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungMerkmalList = createAsyncThunk('meldungMerkmalSlice/loadMeldungMerkmalList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungMerkmalSlice.loadMeldungMerkmalListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldmerkmal/?action=gte&MIN_MELDUNGID=${parentModel.HDR_ID}&MAX_MELDUNGID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungMerkmalListStatus } = getState().meldungMerkmalSlice
        return loadMeldungMerkmalListStatus !== 'pending'
    }
})

export const loadMeldungMerkmal = createAsyncThunk('meldungMerkmalSlice/loadMeldungMerkmal', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/nurismeldmerkmal/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungMerkmalStatus } = getState().meldungMerkmalSlice
        return loadMeldungMerkmalStatus !== 'pending'
    }
})

export const saveMeldungMerkmal = createAsyncThunk('meldungMerkmalSlice/saveMeldungMerkmal', async ({ meldungMerkmal }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldungMerkmal?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurismeldmerkmal/${ meldungMerkmal?.HDR_ID }/`,
            prepareData(meldungMerkmal),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurismeldmerkmal/`,
            prepareData(meldungMerkmal),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungMerkmalStatus } = getState().meldungMerkmalSlice
        return saveMeldungMerkmalStatus !== 'pending'
    }
})

export const deleteMeldungMerkmal = createAsyncThunk('meldungMerkmalSlice/deleteMeldungMerkmal', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurismeldmerkmal/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungMerkmalStatus } = getState().meldungMerkmalSlice
        return deleteMeldungMerkmalStatus !== 'pending'
    }
})

const MeldungMerkmalSlice = createSlice({
    name: 'meldungMerkmalSlice',
    initialState,
    reducers: {
        resetloadMeldungMerkmalListError: (state) => {
            state.loadMeldungMerkmalListError = undefined
        },
        resetloadMeldungMerkmal: (state) => {
            state.formItem = undefined
            state.loadMeldungMerkmalError = undefined
        },
        resetloadMeldungMerkmalError: (state) => {
            state.loadMeldungMerkmalError = undefined
        },
        resetsaveMeldungMerkmal: (state) => {
            state.formItem = undefined
            state.saveMeldungMerkmalError = undefined
        },
        resetsaveMeldungMerkmalError: (state) => {
            state.saveMeldungMerkmalError = undefined
        },
        resetdeleteMeldungMerkmalError: (state) => {
            state.deleteMeldungMerkmalError = undefined
        },
        removeFromMeldungMerkmalListById: (state, action) => {
            state.meldungMerkmalList = state.meldungMerkmalList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungMerkmalListByIds: (state, action) => {
            state.meldungMerkmalList = state.meldungMerkmalList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungMerkmalList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungMerkmalListStatus = 'preloaded'
            state.loadMeldungMerkmalListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungMerkmalList = []
            state.loadMeldungMerkmalListStatus = 'idle'
            state.loadMeldungMerkmalListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungMerkmalList.pending, (state) => {
            state.loadMeldungMerkmalListStatus = 'pending'
            state.loadMeldungMerkmalListError = undefined
        })
        builder.addCase(loadMeldungMerkmalList.fulfilled, (state, action) => {
            state.loadMeldungMerkmalListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungMerkmalListLastArgs = action.payload.args

            {
                state.meldungMerkmalList = action.payload.data

            }
        })
        builder.addCase(loadMeldungMerkmalList.rejected, (state, action) => {
            state.loadMeldungMerkmalListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungMerkmalListError = action.error.message
            } else {
                state.loadMeldungMerkmalListError = action.payload
            }
        })

        builder.addCase(loadMeldungMerkmal.pending, (state) => {
            state.loadMeldungMerkmalStatus = 'pending'
            state.loadMeldungMerkmalError = undefined
        })
        builder.addCase(loadMeldungMerkmal.fulfilled, (state, action) => {
            state.loadMeldungMerkmalStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungMerkmalList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungMerkmalList.push(newItem) }
                else { state.meldungMerkmalList[i] = { ...state.meldungMerkmalList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldungMerkmal.rejected, (state, action) => {
            state.loadMeldungMerkmalStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungMerkmalError = action.error.message
            } else {
                state.loadMeldungMerkmalError = action.payload
            }
        })

        builder.addCase(saveMeldungMerkmal.pending, (state) => {
            state.saveMeldungMerkmalStatus = 'pending'
            state.saveMeldungMerkmalError = undefined
        })
        builder.addCase(saveMeldungMerkmal.fulfilled, (state, action) => {
            state.saveMeldungMerkmalStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungMerkmalList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungMerkmalList.push(newItem) }
                else { state.meldungMerkmalList[i] = { ...state.meldungMerkmalList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldungMerkmal.rejected, (state, action) => {
            state.saveMeldungMerkmalStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungMerkmalError = action.error.message
            } else {
                state.saveMeldungMerkmalError = action.payload
            }
        })

        builder.addCase(deleteMeldungMerkmal.pending, (state) => {
            state.deleteMeldungMerkmalStatus = 'pending'
            state.deleteMeldungMerkmalError = undefined
        })
        builder.addCase(deleteMeldungMerkmal.fulfilled, (state, action) => {
            state.deleteMeldungMerkmalStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungMerkmalList = state.meldungMerkmalList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungMerkmalList = state.meldungMerkmalList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungMerkmal.rejected, (state, action) => {
            state.deleteMeldungMerkmalStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungMerkmalError = action.error.message
            } else {
                state.deleteMeldungMerkmalError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungMerkmalListError,
    resetloadMeldungMerkmal,
    resetloadMeldungMerkmalError,
    resetsaveMeldungMerkmal,
    resetsaveMeldungMerkmalError,
    resetdeleteMeldungMerkmalError,
    removeFromMeldungMerkmalListById,
    removeFromMeldungMerkmalListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungMerkmalSlice.actions
export default MeldungMerkmalSlice.reducer
